import React, { createContext, useState, useEffect, useContext } from "react";
import { Navigate } from "react-router-dom";
import { ShowToast, Severty } from "../helper/toast";
import useRequest from "../hooks/useRequest";
import axios from "axios";
import { useMediaQuery } from "react-responsive";
import { useAuthContext } from "./AuthContext";
export const AppStateContext = createContext();

export const AppContextProvider = ({ children }) => {
  const { request } = useRequest();
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [bannerList, setBannnerList] = useState([]);
  const [prices, setPrices] = useState([]);
  const [vault, setVaulat] = useState([]);
  const [goldPrice, setGoldPrice] = useState(0);
  const [goldRates, setGoldRates] = useState();
  const [prevGoldPrice, setPrevGoldPrice] = useState(null);
  const [goldPriceDifference, setGoldPriceDifference] = useState(0);
  const [silverPrice, setSilverPrice] = useState(0);
  const [silverRates, setSilverRates] = useState();
  const [prevSilverPrice, setPrevSilverPrice] = useState(null);
  const [silverPriceDifference, setSilverPriceDifference] = useState(0);
  const [serviceFee, setServiceFee] = useState();
  const [refreshBalance, setRefreshBalance] = useState(false);
  const [metal, setMetal] = useState([]);
  const [language, setLanguage] = useState("en");

  const [theme, setTheme] = useState(true);

  const { isLoggedIn, setUserProfile } = useAuthContext();

  const isMobile = useMediaQuery({ maxWidth: 767 });

  useEffect(() => {
    let lang = localStorage.getItem("languageSet");
    lang = lang ? lang : "en";

    // let theme = localStorage.setItem("theme", "true");
    // theme = theme ? theme : "true";
    // setTheme(theme);
    // setTimeout(() => setLoading(false), 200);
    setLanguage(lang);
  }, []);

  useEffect(() => {
    if (prices.length) return;
    request({
      url: "/common/product-listing",
      method: "GET",
      onSuccess: ({ data, status }) => {
        if (status) {
          setPrices(data.data);
          setMetal(data.data);
        }
      },
      onError: (error) => { },
    });

    request({
      url: "/admin/service-fees/fees",
      method: "GET",
      onSuccess: ({ data, status }) => {
        if (data.data.length) {
          setServiceFee(data.data[0]);
        }
      },
      onError: (error) => { },
    });
  }, []);

  useEffect(() => {
    if (!isLoggedIn) return;
    request({
      url: "/app/vault/getVaultList",
      method: "GET",
      onSuccess: ({ data, status }) => {
        if (status) {
          setVaulat(data.data);
        }
      },
      onError: (error) => { },
    });
    // Additional logic on login
  }, [isLoggedIn]);

  // Refs to track previous prices throughout the interval life
  const goldPriceRef = React.useRef(0);
  const silverPriceRef = React.useRef(0);

  const getGold = () => {
    request({
      url: "/app/transaction/get-metal-price?category=XAU",
      method: "GET",
      onSuccess: (res) => {
        let livePrice = res.data?.price || 0;

        // Use ref to get the previous price
        const prevPrice = goldPriceRef.current;

        if (prevPrice !== 0) {
          const difference = livePrice - prevPrice;
          setGoldPriceDifference(difference);
        }

        // Update Ref and State
        goldPriceRef.current = livePrice;
        setGoldPrice(livePrice);
        setGoldRates(livePrice);
      },
      onError: (error) => {
        console.log("getGold error:", error);
      }
    });
  };

  useEffect(() => {
    getGold();
    const intervalId = setInterval(() => {
      getGold();
    }, 10000);
    return () => clearInterval(intervalId);
  }, []);

  const getSilver = () => {
    request({
      url: "/app/transaction/get-metal-price?category=XAG",
      method: "GET",
      onSuccess: (res) => {
        let livePrice = res.data?.price || 0;

        const prevPrice = silverPriceRef.current;

        if (prevPrice !== 0) {
          const difference = livePrice - prevPrice;
          setSilverPriceDifference(difference);
        }

        silverPriceRef.current = livePrice;
        setSilverPrice(livePrice);
        setSilverRates(livePrice);
      },
      onError: (error) => {
        console.log(error);
      }
    });
  };

  useEffect(() => {
    getSilver();
    const intervalId = setInterval(() => {
      getSilver();
    }, 10000);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <AppStateContext.Provider
      value={{
        bannerList,
        password,
        email,
        setEmail,
        setPassword,
        prices,
        goldPrice,
        goldRates,
        goldPriceDifference,
        silverPrice,
        silverRates,
        silverPriceDifference,
        serviceFee,
        refreshBalance,
        setRefreshBalance,
        isMobile,
        metal,
        language,
        setLanguage,
        setTheme,
        theme,
      }}
    >
      {children}
    </AppStateContext.Provider>
  );
};

export const useAppContext = () => {
  return useContext(AppStateContext);
};
